/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string')) {
      if ((/^[0-9]+$/.test(time))) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }

    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

export function offlineVisit(type) { //是否到线下医院就诊过
  switch (type) {
    case 1:
      return '是';
    case 0:
      return '否';
    default:
      return '无'
  }
}

export function threeImagesImport(str) { // 舌象图导入
  let res = ['', '', '', ''];
  if (str) {
    let arr = str.split(',');
    for (let i = 0; i < arr.length; i++) {
      let index = i + 1 > 3 ? 0 : i + 1;
      res[index] = arr[i] || '';
    }
  }
  return res;
}

export function threeImagesExport(arr) { // 舌象图导出
  if (arr.length == 4) {
    arr.push(arr.shift());
  }
  return arr;
}

export function inArray(val, arr, name) { //是否存在数组中
	let res = false;
	for (let i = 0; i < arr.length; i++) {
		if (name) {
			if (arr[i][name] == val) {
				res = true;
				break;
			}
		} else {
			if (arr[i] == val) {
				res = true;
				break;
			}
		}
	}
	return res;
}

export const optionsName = (list, val, labelName, valueName) => { // 选项选中名称
	if (!labelName) labelName = 'label';
	if (!valueName) valueName = 'value';
	for (let i = 0; i < list.length; i++) {
		if (list[i][valueName] === val) {
			return list[i][labelName];
		}
	}
	return '';
}